import React, { useEffect, useState } from 'react';
import styles from '../App.module.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Hero = () => {
  const [homeBanner, setHomeBanner] = useState([]);
  const [loading, setLoading] = useState(true);
  const baseurl = process.env.REACT_APP_API_BASE_URL;
  const fetchBannerData = async () => {
    try {
      const response = await fetch(`${baseurl}get-banner.php`);
      // if (!response.ok) {
      //   throw new Error('Network response was not ok');
      // }
      const result = await response.json();
      setHomeBanner(result.data); // Adjust based on your API response
      setLoading(false);        
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    } finally {}
  };
  useEffect(() => {
    fetchBannerData();
  }, [])

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
  };
  
  return (
    <div className={styles.top_section}>
      {
        loading ? (
          <div className="animate-pulse bg-slate-400 w-full" style={{height:"600px"}}>
            <div className="flex flex-col justify-center ps-5 h-full space-y-4">
              <div className="h-10 bg-slate-300 rounded w-2/5"></div>
              <div className="h-8 bg-slate-300 rounded w-36"></div>
            </div>
          </div>
        ):(
          <Slider {...settings}>
            {
              homeBanner.map((item, index) =>
                <div key={index}>
                  <section className={styles.hero} style={{backgroundImage:`url(${item.banner_image})`}}>
                    <div className="container mx-auto">
                      <div className='row'>
                        <div className="col-md-12"> 
                          <h1 className='font-bold uppercase leading-12 text-5xl w-3/5'>{item.title}</h1>
                          <button className="text-xl mt-6 p-2 px-4 uppercase border-yellow-400 border-2 text-white font-semibold hover:bg-yellow-400 transition duration-300">Discover</button>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              )
            }        
          </Slider>
        )
      }
    </div>
  );
}

export default Hero;